// extracted by mini-css-extract-plugin
module.exports = {"affirmMessaging":"affirm_affirmMessaging__9NGbP","affirmMessagingLogo":"affirm_affirmMessagingLogo__Jcr8Q","affirmMessagingV2":"affirm_affirmMessagingV2__xJjWn"};